import {ApiResponse} from "./axios";
import {Channel} from "./channel";
import {VideoContent} from "./video-content";

export interface Conductor extends ApiResponse {
  channelId: string;
  channel: Channel | null;
  title: string;
  rtmp_stream_url: string;
  hls_stream_url: string;
  video_content_id: string;
  video_content: VideoContent;
  slug: string;
  start_stream_time: Date;
  end_stream_time: Date;
  is_active: boolean;
  id: string;
  short_id: string;
  created_at: Date;
  modified_at: Date;
  status: LiveStreamConductorStatus;
  stream_slug: string;
}

export enum LiveStreamConductorStatus {
  waiting_for_start_stream_date = 0,
  stream_started_automatically = 1,
  stream_started_manually = 2,
  stream_ended_automatically = 3,
  stream_ended_manually = 4,
  stream_paused_manually = 5
}


export interface ChannelsState {
  readonly loading: boolean
  readonly allIds: String[]
  readonly byId: object
  readonly count: number
}
